<template>
  <button 
    @click="handleLogin"
    :disabled="loading"
    class="btn-white"
  >
    {{ loading ? 'Entrando...' : 'Entrar' }}
  </button>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth.js'

const authStore = useAuthStore()
const router = useRouter()
const loading = ref(false)

const handleLogin = async () => {
  loading.value = true
  try {
    await authStore.login()
    // Redirecionar para dashboard após login bem-sucedido
    router.push({name: 'Dashboard'})
  } catch (error) {
    console.error('Erro no login:', error)
  } finally {
    loading.value = false
  }
}
</script>